import { Button, Stack, Typography } from '@40seas/frontend/common/components';
import { Dialog } from '@mui/material';
import { useDashboardLocaleKeys } from 'frontend/apps/dashboard/assets/locale/auto-generated/dashboardLocaleKeys';

export const InactivityPopupView = ({ onRefreshClicked }) => {
    const locale = useDashboardLocaleKeys().customComponents.inactivityPopup;

    return (
        <Dialog open={true}>
            <Stack p={3}>
                <Typography variant="subtitle2">{locale.title()}</Typography>
                <Typography>{locale.description()}</Typography>
                <Button label={locale.refresh()} onClick={onRefreshClicked} sx={{ alignSelf: 'end' }} />
            </Stack>
        </Dialog>
    );
};
